'use strict';

window.quill = {
	hasInit: false,
	uploads: {},
};

define('quill-nbb', [
	'composer/resize',
	'components',
	'quill',
	'composer/image',
	'composer/video',
	'composer/online-video',
	'composer/link',
	'composer/divider',
], (resize, components, Quill, Image, Video, OnlineVideo, Link, Divider) => {
	$(window).on('action:composer.loaded', (ev, data) => {
		var postContainer = $(`.composer[data-uuid="${data.post_uuid}"]`);
		var targetEl = postContainer.find('.write-container div');
		if (targetEl.length) {
			window.quill.init(targetEl, data);
		}
		resize.reposition(postContainer);
	});

	$(window).on('action:composer.check', (ev, data) => {
		var quill = components.get('composer').filter(`[data-uuid="${data.post_uuid}"]`).find('.ql-container').data('quill');
		const ctx = quill.getContents();
		data.bodyLen = quill.getLength() - 1;
		data.isEmpty = window.quill.isEmpty(quill);
		data.contents = JSON.stringify(ctx);
		data.originContents = ctx;
	});

	$(window).on('action:composer.uploadError', (evt, data) => {
		const quill = components.get('composer').filter(`[data-uuid="${data.post_uuid}"]`).find('.ql-container').data('quill');
		const textareaEl = components.get('composer').filter(`[data-uuid="${data.post_uuid}"]`).find('textarea');
		if (quill && textareaEl) {
			textareaEl.val(!window.quill.isEmpty(quill) ? JSON.stringify(quill.getContents()) : '');
			textareaEl.trigger('change');
			textareaEl.trigger('keyup');
		}
	});

	if (window.quill.hasInit) {
		return;
	}
	window.quill.hasInit = true;
	window.quill.init = function (targetEl, data, callback) {
		const textDirection = $('html').attr('data-dir');
		const textareaEl = targetEl.siblings('textarea');

		Quill.register({ 'formats/image': Image }, true);
		Quill.register({ 'formats/video': Video }, true);
		Quill.register({ 'formats/online-video': OnlineVideo }, true);
		Quill.register({ 'formats/link': Link }, true);
		Quill.register({ 'formats/divider': Divider }, true);
		const quill = new Quill(targetEl.get(0), {
			theme: data.theme || 'snow',
			modules: {
				clipboard: true,
				history: false,
				toolbar: [
					['link'],
				],
			},
			bounds: data.bounds || document.body,
			placeholder: 'Say something...',
			scrollingContainer: '#quill-scroll-container',
		});
		targetEl.data('quill', quill);
		$(window).trigger('action:quill.load', quill);

		if (data.composerData && data.composerData.body) {
			try {
				const unescaped = data.composerData.body.replace(/&quot;/g, '"');
				const delta = JSON.parse(unescaped);
				quill.setContents(delta, 'api');
			} catch (e) {
				quill.setContents({
					ops: [{
						insert: data.composerData.body.toString(),
						attributes: {
							direction: textDirection,
							align: textDirection === 'rtl' ? 'right' : 'left',
						},
					}],
				}, 'api');
			}
		}

		// Automatic RTL support
		quill.format('direction', textDirection);
		quill.format('align', 'left');

		// Update textarea on editor-change event. This allows compatibility with
		// how NodeBB handles things like drafts, etc.
		quill.on('editor-change', () => {
			textareaEl.val(JSON.stringify(quill.getContents()));
			textareaEl.trigger('change');
			textareaEl.trigger('keyup');
		});


		// Special handling on text-change
		let scrollTimeout = 0;
		quill.on('text-change', (delta, oldDelta, source) => {
			if (source === 'user' && delta.ops && delta.ops[1] && delta.ops[1].delete && window.uploads && window.uploads.queue.size) {
				const diffs = [];
				window.uploads.queue.forEach((info, id) => {
					if (!document.getElementById(`ql-media__${id}`)) {
						diffs.push(info);
					}
				});
				diffs.forEach((info) => {
					if (info && info.aws) {
						info.aws.forEach((awsIns) => {
							awsIns.abort();
						});
					}
				});
			}

			if (scrollTimeout) {
				clearTimeout(scrollTimeout);
				scrollTimeout = 0;
			}

			setTimeout(() => {
				if (window.quill.isEmpty(quill)) {
					quill.deleteText(0, quill.getLength());
					textareaEl.val('');
					$('#createBallot').prop('disabled', false).attr('disabled', false);
					$('#forumPreview').prop('disabled', true).attr('disabled', true);
				} else {
					$('#createBallot').prop('disabled', true).attr('disabled', true);
					$('#forumPreview').prop('disabled', false).attr('disabled', false);
				}
			}, 10);
		});

		if (typeof callback === 'function') {
			callback();
		}

		// targetEl.find('.ql-editor').on('click', function () {
		// textareaEl.focus();
		// });

		return window.quill;
	};

	window.quill.isEmpty = function (quill) {
		const contents = quill.getContents();

		if (contents.ops.length === 1) {
			const value = contents.ops[0].insert.replace(/[\s\n]/g, '');
			return value === '';
		}

		return false;
	};
});
